export default {
    lang: 'en',
    company: 'novel.keepreadingbook.com',
    name: 'NovelKeepreadingbook',
    email: 'selinachen980@gmail.com',
    bgImg: 'https://static.novelfreedom.com/paynovel/h5-pay-asia/top-bg-blue.png',
    theme: '#5e91ee',
    discoverIcon: 'https://static.novelfreedom.com/paynovel/h5-pay-asia/icon_discover_active-blue.png',
    mineIcon:'https://static.novelfreedom.com/paynovel/h5-pay-asia/icon_mine_active-blue.png',
    logo: 'https://static.novelfreedom.com/paynovel/h5-pay-asia/countnovel-logo.png',
    isAds: false,
    about: `
        <div>
            <article>
                <h1>About Us: NovelKeepReadingBook</h1>
                <section>
                    <p>
                        We are an application independently developed by <b>TerraFlow Limited</b>, a company specializing in providing users with high-quality novels, with a large number of novel Copyrights, and can recommend specific novel content according to different preferences of users, bringing super feelings to your reading experience.
                    </p>
                    <p>
                        We have a complete copyright system, there is no legal risk.
                    </p>
                    <p>
                        If you have any questions, please contact us at selinachen980@gmail.com
                    </p>
                    <p>
                        We will get back to you as soon as we see it.
                    </p>
                </section>
            </article>
        </div>
    `,
    serviceP1:`
        This Seal Novel service agreement (Hereinafter referred to as "Agreement") is entered into by and between <b>TerraFlow Limited</b>(Address: Aegis Chambers, 1st Floor, Ellen Skelton Building, 3076 Sir Francis Drake's Highway, Road Town, Tortola, VG1110, British Virgin Islands.) and Seal Novel's users (Hereinafter referred to as "Users"), concerning the installation, usage and related matters of "NovelKeepreadingbook" application (Hereinafter referred to as "NovelKeepreadingbook"). By clicking "I agree" or other ways to accept the Agreement, you acknowledge that you have reached an agreement with Seal Novel and accept all the following terms and conditions.
    `,
    fbPixel: {
        1: '1438847163760449',
    },
    adx: {
        1: '/29746187,23215273386/HK_CN_keepreadingbook.com_banner_t2',
    },
    ads: {
        1: '5142653642',
        2:'2968211590',
    },
    adsCaPubId: '7241813899388863',
    ga4: {
        id: 'G-HVDMNM67J9'
    },
    adConfig: {
        default: {
            // 关闭遮罩时间
            closeMaskTime: 20000,
            // 倒计时时间
            time: 40000,
            // 20s 计数
            interTime: 20,
            // 是否可以点击穿透
            // 点击广告上线
            clickMax: 3,
        }
    },
    content:{
        1: {
            split: '\n\n',
            textNum: 2000,
            p: 10,
        },
    },
    pixelReport: {
        default: {
            chapter: new Set([1, 3, 5, 10, 20, 30]),
            rate: 0.6
        }
    }
}